import * as React from 'react'
import { SVGProps, Ref, forwardRef, memo } from 'react'

const SvgSideAggregation = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 25 25"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="M19.914 1.308a3.667 3.667 0 0 1 3.667 3.666v14.667a3.667 3.667 0 0 1-3.667 3.667H5.248A3.667 3.667 0 0 1 1.58 19.64V4.974a3.667 3.667 0 0 1 3.667-3.666h14.666Zm0 1.833H5.248c-.94 0-1.715.708-1.821 1.62l-.013.213v14.667c0 .94.708 1.715 1.62 1.821l.214.012h14.666c.94 0 1.715-.707 1.821-1.62l.013-.213V4.974c0-.94-.708-1.715-1.62-1.82l-.214-.013Zm-8.44 1.833 4.628 4.696h-3.795l.001 4.574-4.158 1.439v3.589H6.318v-4.895l4.158-1.44V9.669H6.8l4.675-4.695Zm2.294 7.75 4.774 1.653v4.895h-1.833V15.68l-3.54-1.224.599-1.732Z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </svg>
)

const ForwardRef = forwardRef(SvgSideAggregation)
const Memo = memo(ForwardRef)
export default Memo
